import React, { useState, useEffect } from 'react';
import api, { getUploadUrl } from '../services/api';
import { getUser } from '../services/auth';
import { Link } from 'react-router-dom';
import { compartilhar } from '../services/share';
import { parseDataJogo } from '../utils/dataJogo';
import Icon from '../components/Icon';
import Crest from '../components/Crest';
import './Home.css';

function formatData(d) {
  return parseDataJogo(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

function ModalComoFunciona({ onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-titulo"><Icon name="target" size={18} /> Como Funciona a Plataforma?</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">

          <div className="regra-item">
            <div className="regra-icone">1️⃣</div>
            <div className="regra-conteudo">
              <h3>Faça seus palpites</h3>
              <p>Escolha os resultados dos jogos disponíveis e envie seus palpites antes do horário de início das partidas.</p>
            </div>
          </div>

          <div className="regra-item destaque-verde">
            <div className="regra-icone">2️⃣</div>
            <div className="regra-conteudo">
              <h3>Ganhe pontos</h3>
              <p>Cada placar acertado vale:</p>
              <div className="pontos-badge">+5 pontos</div>
              <p>Os pontos ficam acumulados em sua conta.</p>
            </div>
          </div>

          <div className="regra-item">
            <div className="regra-icone">3️⃣</div>
            <div className="regra-conteudo">
              <h3>Troque por prêmios</h3>
              <p>Acesse a aba <strong>Prêmios</strong> para visualizar os brindes disponíveis. Cada prêmio possui uma pontuação mínima para resgate. Quanto mais você acertar, mais prêmios conquista!</p>
            </div>
          </div>

          <div className="regra-item destaque-primary">
            <div className="regra-icone">4️⃣</div>
            <div className="regra-conteudo">
              <h3>Mensalidade</h3>
              <p>Para participar da plataforma, o valor é de apenas:</p>
              <div className="valor-badge"> 9,99 / mês</div>
            </div>
          </div>

          <div className="regra-item">
            <div className="regra-icone">5️⃣</div>
            <div className="regra-conteudo">
              <h3>Pagamento via PIX</h3>
              <p>Após realizar o pagamento, acesse <strong>"Enviar Comprovante PIX"</strong> no seu perfil. Seu comprovante será analisado pela administração e seu acesso será liberado.</p>
            </div>
          </div>

          <div className="regra-item destaque-verde">
            <div className="regra-icone">🏅</div>
            <div className="regra-conteudo">
              <h3>Pontos para todos que acertarem</h3>
              <p>Todos os usuários que acertarem o placar recebem <strong>+5 pontos integrais</strong>. Os pontos não são divididos entre os vencedores.</p>
              <p>Exemplo: se 20 usuários acertarem, todos os 20 recebem 5 pontos.</p>
            </div>
          </div>

          <div className="regra-item">
            <div className="regra-icone">📦</div>
            <div className="regra-conteudo">
              <h3>Estoque limitado nos prêmios</h3>
              <p>Alguns brindes possuem quantidade limitada. Os primeiros a resgatarem enquanto houver estoque garantem o prêmio.</p>
              <p>Quem não conseguir resgatar <strong>mantém seus pontos</strong> para usar em outros brindes ou quando o estoque for reposto.</p>
            </div>
          </div>

          <div className="regra-acesso">
            <h3>⚠️ Contas com pendência</h3>
            <div className="acesso-grid">
              <div className="acesso-col pode">
                <div className="acesso-col-titulo">✅ Podem</div>
                <ul>
                  <li>Acessar a plataforma</li>
                  <li>Visualizar ranking</li>
                  <li>Ver premiações</li>
                  <li>Editar perfil</li>
                  <li>Enviar comprovante PIX</li>
                </ul>
              </div>
              <div className="acesso-col nao-pode">
                <div className="acesso-col-titulo">❌ Não podem</div>
                <ul>
                  <li>Visualizar jogos</li>
                  <li>Realizar palpites</li>
                  <li>Participar das rodadas</li>
                </ul>
              </div>
            </div>
            <p className="acesso-obs">Após o envio e aprovação do comprovante, o acesso é liberado automaticamente.</p>
          </div>

          <div className="regra-footer">
            🏆 Quanto mais palpites corretos você fizer, mais pontos acumula e mais prêmios pode resgatar!
          </div>

        </div>
      </div>
    </div>
  );
}

export default function Home() {
  const user = getUser();
  const [proximos, setProximos] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [posicao, setPosicao] = useState(null);
  const [premiacoes, setPremiacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAberto, setModalAberto] = useState(false);
  const [banner, setBanner] = useState(null);
  const [bannerComErro, setBannerComErro] = useState(false);

  useEffect(() => {
    if (!user?.cidade_id) { setLoading(false); return; }
    Promise.all([
      api.get(`/jogos?campeonato_id=&finalizado=0`),
      api.get(`/jogos?finalizado=1`),
      api.get('/ranking/minha-posicao'),
      api.get('/premiacoes'),
    ]).then(([j, r, pos, pre]) => {
      setProximos(j.slice(0, 5));
      setResultados(r.slice(0, 5));
      setPosicao(pos.posicao);
      setPremiacoes(pre.slice(0, 3));
    }).catch(() => {}).finally(() => setLoading(false));
  }, [user?.cidade_id]);

  // Busca separada e silenciosa: o banner nunca atrasa nem quebra a Home.
  useEffect(() => {
    api.get('/banners').then(data => setBanner(data[0] || null)).catch(() => {});
  }, []);

  useEffect(() => {
    if (modalAberto) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [modalAberto]);

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div className="home">
      {banner && !bannerComErro && (
        banner.link ? (
          <a href={banner.link} target="_blank" rel="noopener noreferrer" className="home-banner">
            <img src={getUploadUrl(banner.imagem)} alt={banner.titulo || 'Banner'} onError={() => setBannerComErro(true)} />
          </a>
        ) : (
          <div className="home-banner">
            <img src={getUploadUrl(banner.imagem)} alt={banner.titulo || 'Banner'} onError={() => setBannerComErro(true)} />
          </div>
        )
      )}

      <div className="home-hero">
        <div className="home-hero__top">
          <span className="home-hero__hi">Olá, {user?.nome?.split(' ')[0]}</span>
        </div>
        <div className="hero-info">
          <span className="hero-pts">{user?.pontos || 0}</span>
          <span className="hero-pts-label">pontos</span>
        </div>
        <div className="hero-rank">
          {posicao
            ? <><Icon name="fire" size={13} /><span className="hero-pos">#{posicao}</span><span className="hero-pos-label">no ranking</span></>
            : <span className="hero-pos-label">Faça seus palpites!</span>}
        </div>
      </div>

      <button className="btn-compartilhar" onClick={() => compartilhar(user?.pontos)}>
        <Icon name="share" size={14} /> Compartilhar o Palpitar
      </button>

      {/* Card Como Funciona */}
      <div className="como-funciona-card">
        <div className="como-funciona-left">
          <span className="como-funciona-icone"><Icon name="target" size={20} /></span>
          <div>
            <p className="como-funciona-titulo">Como Funciona?</p>
            <p className="como-funciona-sub">Entenda o sistema de palpites, pontos e prêmios</p>
          </div>
        </div>
        <button className="btn-ver-regras" onClick={() => setModalAberto(true)}>
          Ver Regras
        </button>
      </div>

      {/* Card Figurinha */}
      <Link to="/figurinha" className="como-funciona-card como-funciona-card--gold">
        <div className="como-funciona-left">
          <span className="como-funciona-icone"><Icon name="trophy" size={20} /></span>
          <div>
            <p className="como-funciona-titulo">Figurinha Premium</p>
            <p className="como-funciona-sub">Sua identidade oficial de torcedor na Palpitar</p>
          </div>
        </div>
        <span className="btn-ver-regras btn-ver-regras--gold">Ver <Icon name="chevron" size={12} /></span>
      </Link>

      <section className="home-section">
        <div className="section-header">
          <h2>Próximos Jogos</h2>
          <Link to="/jogos">Ver todos</Link>
        </div>
        {proximos.length === 0 ? <p className="empty">Nenhum jogo programado.</p> : (
          <div className="hscroll">
            {proximos.map(j => (
              <div key={j.id} className="matchcard">
                <span className="matchcard__comp">{j.campeonato_nome}</span>
                <div className="matchcard__row">
                  <Crest nome={j.time_casa_nome} escudo={j.time_casa_escudo} />
                  <span className="matchcard__vs">{formatData(j.data_jogo)}</span>
                  <Crest nome={j.time_fora_nome} escudo={j.time_fora_escudo} />
                </div>
                <span className="matchcard__names">{j.time_casa_nome} <i>vs</i> {j.time_fora_nome}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="home-section">
        <div className="section-header">
          <h2>Últimos Resultados</h2>
          <Link to="/jogos">Ver todos</Link>
        </div>
        {resultados.length === 0 ? <p className="empty">Nenhum resultado ainda.</p> : (
          <div className="hscroll">
            {resultados.map(j => (
              <div key={j.id} className="matchcard">
                <span className="matchcard__comp">{j.campeonato_nome}</span>
                <div className="matchcard__row">
                  <Crest nome={j.time_casa_nome} escudo={j.time_casa_escudo} />
                  <span className="matchcard__vs matchcard__vs--placar">{j.gols_casa} x {j.gols_fora}</span>
                  <Crest nome={j.time_fora_nome} escudo={j.time_fora_escudo} />
                </div>
                <span className="matchcard__names">{j.time_casa_nome} <i>vs</i> {j.time_fora_nome}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="home-section">
        <div className="section-header">
          <h2>Premiações</h2>
          <Link to="/premiacoes">Ver todas</Link>
        </div>
        <div className="premios-grid">
          {premiacoes.map(p => (
            <div key={p.id} className="premio-card">
              {p.imagem
                ? <img src={getUploadUrl(p.imagem)} alt={p.nome} className="premio-img" />
                : <span className="premio-icon"><Icon name="gift" size={22} /></span>
              }
              <span className="premio-nome">{p.nome}</span>
              <span className="premio-pts">{p.pontuacao_necessaria} pts</span>
            </div>
          ))}
        </div>
      </section>

      {modalAberto && <ModalComoFunciona onClose={() => setModalAberto(false)} />}
    </div>
  );
}
